import axios from '../../api/index.js';

//查询字典列表
export let getDict = (params) => {
    return axios.post(`/client/wm_dict/list`,params);
};


// WEBPACK FOOTER //
// ./src/api/wm_news/dict.js